import { Link } from '@on3/ui-lib/components/Link';
import { Pen } from '@on3/ui-lib/components/Svg';
import { useAuth } from '@on3/ui-lib/index';
import { handleKeyDown } from '@on3/ui-lib/utils/accessibility/keyDown';
import { userHasPermission } from '@on3/ui-lib/utils/auth/access';
import { profileAdmin } from '@on3/ui-lib/utils/auth/constants';
import clsx from 'clsx';
import useAthlete from 'contexts/AthleteProvider';
import { useState } from 'react';
import { createDescription } from 'utils/meta';

import styles from './PlayerBio.module.scss';

interface PlayerBioResponse {
  description?: string | null;
}

export const PlayerBio = ({ description }: PlayerBioResponse) => {
  const { athlete, hasBaseProfile } = useAthlete();
  const { user } = useAuth();
  const [showBio, setShowBio] = useState<boolean>(false);

  const canEdit = userHasPermission(profileAdmin, user) && hasBaseProfile;

  const playerDescription =
    hasBaseProfile && !description
      ? createDescription(
          `{0} is a class of {1} {2}.`,
          athlete.name,
          athlete.classYear,
          (athlete.primaryPosition?.name &&
            athlete.highSchool?.name &&
            `${athlete.primaryPosition.name} at ${athlete.highSchool.name}`) ||
            'athlete',
        )
      : description;

  if (!playerDescription) return null;

  return (
    <section className={styles.block}>
      <h2>Personal Life</h2>
      {playerDescription.length > 400 ? (
        <div
          aria-expanded={showBio}
          className={clsx(styles.bio, {
            [styles.clamp]: !showBio,
          })}
          onClick={() => (showBio ? null : setShowBio(!showBio))}
          onKeyDown={handleKeyDown}
          role="button"
          tabIndex={0}
        >
          <p>{description}</p>
        </div>
      ) : (
        <p className={styles.bio}>{playerDescription}</p>
      )}
      {canEdit && (
        <Link
          className={styles.edit}
          href={`/db/${athlete.slug}/elite/network/profile/bio/`}
        >
          <Pen />
          Edit Bio
        </Link>
      )}
    </section>
  );
};
